import React from "react";
import { Grid } from "@material-ui/core";

import FootfallLevelInOutputArea from "./FootfallLevelInOutputArea";
import ChangeInFootfallLevel from "./ChangeInFootfallLevel";
import FootfallByOutputArea from "./FootfallByOutputArea";
import FootfallAnalysis from "./FootfallAnalysis";
import FootfallPositioning from "./FootfallPositioning";

const Footfall = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <FootfallLevelInOutputArea />
            </Grid>
            <Grid item xs={12} md={6}>
                <ChangeInFootfallLevel />
            </Grid>
            <Grid item xs={12}>
                <FootfallByOutputArea />
            </Grid>
            <Grid item xs={12}>
                <FootfallAnalysis />
            </Grid>
            <Grid item xs={12}>
                <FootfallPositioning />
            </Grid>
        </Grid>
    );
};

export default Footfall;
